import React, { Component } from 'react';
import { Avatar, Anchor, Menu, Icon, Row, Col, Dropdown, Divider, Popover, Button } from 'antd';
import Flag from 'react-flagkit';
import './TopRightHeader.less';
import config from 'react-global-configuration';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import * as actionLanguageSwitcherConst from '../../redux/languageSwitcher/actions';

class TopRightHeader extends Component {

    changeLang = ({ key }) => {
        this.props.changeLanguage(key);
    };

    nameHelper = (name) => {
        if (!isMobile) return name;

        let splitName = name.split(" ");

        if (this.props.language === 'en')
            return splitName[0] + " " + splitName[1][0].toUpperCase() + ".";
        else
            return splitName[0];
    }

    render() {

        const locales = ['th', 'en'];
        const languageLabels = {
            'th': 'ภาษาไทย',
            'en': 'English',
        };
        const languageIcons = {
            'th': 'TH',
            'en': 'GB',
        };

        let wasteApiBaseUrl = config.get("wasteApiBaseUrl");

        const langMenu = (
            <Menu selectedKeys={this.props.language} onClick={this.changeLang}>
                {locales.map(locale => (
                    <Menu.Item key={locale}>
                        <Flag country={languageIcons[locale]} size={20} />&nbsp;&nbsp;{languageLabels[locale]}
                    </Menu.Item>
                ))}
            </Menu>
        );

        return (
            <Col sm={12} className="header-index-right">

                <Dropdown overlay={langMenu} trigger={['click']}>
                    <a className="ant-dropdown-link" href="#" style={{ textDecoration: 'none' }} style={{ color: 'white' }}>
                        <Flag country={languageIcons[this.props.language]} size={20} />{!isMobile ? "  " + languageLabels[this.props.language] : null} <Icon type="down" />
                    </a>
                </Dropdown>

                <Divider type="vertical" />

                <Popover content={
                    <React.Fragment>
                        <div style={{textAlign: 'center'}}><Avatar size="large" src={wasteApiBaseUrl + '/file/avatar/' + this.props.currentUser.pkId + '.jpg'} /></div>
                        <br />
                        <strong>{this.props.currentUser.nameEn}</strong>
                        <br />
                        <span style={{ fontStyle: 'italic' }}>{this.props.currentUser.position}</span>
                        <Divider />
                        <Link to="/auth/logout"><Button type="default"><Icon type="logout" /> Log Out</Button></Link>
                    </React.Fragment>
                }
                    title={<strong>Your Profile</strong>}
                    placement="bottomRight"
                >
                    <Button style={{ border: 'none', boxShadow: 'none', color: 'white', backgroundColor: 'transparent' }}>
                        <Avatar src={wasteApiBaseUrl + '/file/avatar/' + this.props.currentUser.pkId + '.jpg'} /> &nbsp;{this.props.currentUser.nameEn}
                    </Button>
                </Popover>

            </Col>
            )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.LanguageSwitcher.language,
        currentUser: state.CurrentUser.currentUser
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changeLanguage: (payload) => dispatch({ type: actionLanguageSwitcherConst.CHANGE_LANGUAGE, payload: payload })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TopRightHeader);
